import { useEffect, useState } from "react";
import { IDocumentMastDropdown } from "../../models/IDropdown";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { PODocType } from "../../models/FDropdown";
import { JVDate } from "../../shared/JVDate";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { format } from "date-fns";
import { LeagleComments } from "../leagalDocument/LeagleComments";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IPaperWork {
    document_Type?: string,
    document_ID?: number,
    pO_ID?: number,
    consultant_ID?: number,//Consultant
    sub_Vendor_ID?: number,//Vendor
    prime_Vendor_ID?: number,//Client
    document_Name?: string,
    expiration_Date?: Date | string,
    document_Path?: string,
    addedBy?: number,
    addedByName?: string,
    editedBy?: number,
    editedByName?: string,
    document_Status?: string,
    addedOn?: Date
}
interface Iprops {
    po: IPurchaseOrder
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

const schema = yup.object({
    document_Type: yup.string().required("Select Document Type"),
    document_Name: yup.string().required("Select Document Name").min(1, "Select Document Name"),
    // expiration_Date: yup.date().nullable().required("Expiration Date is required").typeError("Expiration Date is required")
});

export const APW = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>();
    const [documentsList, setDocumentsList] = useState<{
        consultant_documents: Array<IPaperWork>,
        vendor_documents: Array<IPaperWork>,
        client_documents: Array<IPaperWork>,
    }>({ consultant_documents: [], client_documents: [], vendor_documents: [] });
    const [openClauseModal, setOpenClauseModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IPaperWork });

    const [paperWork, setPaperWork] = useState<IPaperWork>({ document_Type: "Consultant" });

    const { control, handleSubmit, unregister, formState: { errors }, reset, setValue, watch } = useForm<IPaperWork>({
        resolver: yupResolver(schema),
        defaultValues: { document_Type: "Consultant" },
        shouldFocusError: false
    });
    const selectedDocument = watch("document_Name");

    const loadDocuments = async (type?: string) => {
        const response = await Fetch("Dropdown/document", "GET", null, null, null);
        if (response) {
            const data: Array<IDocumentMastDropdown> = await response.json();
            const consultant: Array<IDocumentMastDropdown> = [];
            const Vendor: Array<IDocumentMastDropdown> = [];
            const Client: Array<IDocumentMastDropdown> = [];
            data.forEach((d: IDocumentMastDropdown) => {
                if (!(d.document_Name.includes("Vendor") || d.document_Name.includes("Client"))) consultant.push(d);
                if ((d.document_Name.includes("Vendor"))) Vendor.push(d);
                if ((d.document_Name.includes("Client"))) Client.push(d);
            });
            if (type === "Consultant") {
                setDocuments(consultant);
            } else if (type === "Vendor") {
                setDocuments(Vendor);
            } else if (type === "Client") {
                setDocuments(Client);
            } else {
                setDocuments(consultant);
            }

        }
    }

    const loadDocumentsList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetails/apw", "GET", null, `po_id=${props.po.pO_ID}`, props.toast);
        if (response) {
            const data: {
                consultant_documents: Array<IPaperWork>,
                vendor_documents: Array<IPaperWork>,
                client_documents: Array<IPaperWork>,
            } = await response.json();
            setDocumentsList(data);
        }
        setLoading(false);
    }

    useEffect(() => { loadDocuments(); }, []);
    useEffect(() => {
        if (props.open && props.po.pO_ID) loadDocumentsList();
    }, [props.open, props.po.pO_ID]);
    useEffect(() => {
        let expiration_Date;
        if (paperWork?.expiration_Date) expiration_Date = new Date(paperWork.expiration_Date);
        reset({ ...paperWork, expiration_Date });
    }, [paperWork]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "document_Type") {
                if (value.document_Type === "Vendor" && value.document_Type != null) {
                    loadDocuments("Vendor");

                } else if (value.document_Type === "Client" && value.document_Type != null) {
                    loadDocuments("Client");

                } else if (value.document_Type === "Consultant" && value.document_Type != null) {
                    loadDocuments("Consultant");
                } else {
                    loadDocuments("Consultant");
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const saveDocument = async (body: IPaperWork, isDelete?: boolean) => {
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        body.consultant_ID = props.po.consultant_ID;
        body.sub_Vendor_ID = props.po.sub_Vendor_ID;
        body.prime_Vendor_ID = props.po.prime_Vendor;
        if (isDelete) {
            const response = await Fetch("vwPODetails/apw", "DELETE", body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', content: `Document Deleted Successfully` });
                setPaperWork({ document_Type: "Consultant" });
                loadDocumentsList();
            } else setLoading(false);
        } else {
            const method = body.document_ID ? "PUT" : "POST";
            const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

            const response = await Fetch("vwPODetails/apw", method, body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', content: `Document ${message}` });
                setPaperWork({ document_Type: "Consultant" });
                loadDocumentsList();
            } else setLoading(false);
        }
    }

    function onSubmit(data: IPaperWork) {
        if ((typeof selectedDocument === "string" &&
            selectedDocument !== "1099" &&
            selectedDocument !== "SSN" &&
            selectedDocument !== "W2" &&
            selectedDocument !== "W4" &&
            selectedDocument !== "Vendor VOID CHECK"
            && selectedDocument !== "Vendor ACH")) {
            if (data.expiration_Date == "" || data.expiration_Date == null) {
                props.toast.current.show({ severity: 'error', content: "please select expiration date" });

            } else {
                saveDocument(data);
            }
        } else {
            saveDocument(data);
        }
    }

    const fileUploade = async (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 1024000) {
            props.toast.current.show({ severity: 'error', content: "Document should be less than 1 MB." });
            event.options.clear();
        } else {
            let resp = await uploadeFile(event.files[0]);
            if (resp) {
                event.options.clear();
            }
        }
    }

    const uploadeFile = async (file: File) => {
        setLoading(true);
        let formData = new FormData();
        formData.append("file", file);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Ticket/file`, params);
        if (response) {
            const data = await response.text();
            setValue("document_Path", data);
            props.toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
        }
        setLoading(false);

        return response ? true : false;
    }

    const downloadDocument = async (data: IPaperWork) => {
        data.pO_ID = props.po.pO_ID;
        data.consultant_ID = props.po.consultant_ID;
        data.sub_Vendor_ID = props.po.sub_Vendor_ID;
        data.prime_Vendor_ID = props.po.prime_Vendor;
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetails/document"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.document_Path ? data.document_Path : "document";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    function onHide() {
        props.hideDialog();
        setDocumentsList({ consultant_documents: [], client_documents: [], vendor_documents: [] });
        setPaperWork({ document_Type: "Consultant" });
    }

    const expiration_Date = (rowData: IPaperWork) => {
        let date;
        if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const file = (rowData: IPaperWork) => {
        return (<span onClick={() => downloadDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };
    const actionBodyTemplate = (rowData: IPaperWork) => {
        return <div style={{ display: 'flex' }}>
            {rowData.document_Name?.includes("Client") && <Button icon="pi pi-plus" className="p-button-rounded  p-button-text" tooltip="Add Clause Comment" onClick={() => {
                setOpenClauseModal({ open: true, singleData: rowData });
            }} />}
            <Button icon="pi pi-pencil" tooltip="Update" className="p-button-rounded  p-button-text" onClick={() => {
                loadDocuments(rowData.document_Type);
                setPaperWork({ ...rowData });
            }} />
            <Button icon="pi pi-trash" tooltip="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => saveDocument({ ...rowData }, true)} />
        </div>
    };

    const document_Status = (rowData: IPaperWork) => {
        return (
            rowData.document_Name === "1099" ||
            rowData.document_Name === "W2" ||
            rowData.document_Name === "W4" ||
            rowData.document_Name === "SSN" ||
            rowData.document_Name === "Vendor VOID CHECK" || rowData.document_Name === "Vendor ACH"
        ) ? "" : (
            <span className="cursor-pointer text-cyan-700 ">{rowData.document_Status}</span>
        );
    };
    useEffect(() => {
        if (
            selectedDocument === "1099" ||
            selectedDocument === "W2" ||
            selectedDocument === "W4" ||
            selectedDocument === "SSN" ||
            selectedDocument === "Vendor VOID CHECK" || selectedDocument === "Vendor ACH"
            // (selectedDocument !== "SSN" && selectedDocument !== "W2" && selectedDocument !== "W4")
        ) {
            unregister("expiration_Date");
        }
    }, [selectedDocument, unregister]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Consultant/Vendor/Client Document" className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={[props.po]} showGridlines
            >
                <Column field="company_Name_Sales" header="Company Name" />
                <Column field="salesmanager" header="Sales Manager" />
                <Column field="user_Name" header="Recruiter" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="project_Client_Name" header="End Client" />
                {/* <Column field="project_Start_Date1" header="Start Date" /> */}
                <Column field="project_Start_Date1" header="Start Date" body={(rowData: any) => safeFormatDate(rowData.project_Start_Date1, 'dd/MM/yyyy', DateFormat)} />
                <Column field="bRate" header="B Rate" />
                <Column field="sRate" header="S Rate" />
                <Column field="mRate" header="Margin " />
                <Column field="vendor_Company_Name" header="Client" />
                <Column field="sub_Vendor_Company" header="Vendor" />
                {/* <Column field="pO_Date1" header="PO Date" /> */}
                <Column field="pO_Date1" header="PO Date" body={(rowData: any) => safeFormatDate(rowData.pO_Date1, 'dd/MM/yyyy', DateFormat)} />
                <Column field="pO_Status" header="Status" />
            </DataTable>
            {/* {selectedRoles && selectedRoles.some(role => role.role_Name === "Recruitment Head") &&  */}
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Type" control={control} name="document_Type" error={errors.document_Type?.message} options={PODocType} optionLabel="name" optionValue="name" placeholder="Select Document Type" />
                <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Name" control={control} name="document_Name" error={errors.document_Name?.message} options={documents} optionLabel="document_Name" optionValue="document_Name" placeholder="Select Document Name" />
                {(
                    (typeof selectedDocument === "string" &&
                        selectedDocument !== "1099" &&
                        selectedDocument !== "SSN" &&
                        selectedDocument !== "W2" &&
                        selectedDocument !== "W4" &&
                        selectedDocument !== "Vendor VOID CHECK"
                        && selectedDocument !== "Vendor ACH")
                ) && <JVDate column={2} label="Expiration Date" minDate={new Date()} required control={control} name="expiration_Date" error={errors.expiration_Date?.message} />}
                <div className="field col-12 md:col-3">
                    <label htmlFor="file">Document<span style={{ color: 'red' }}>*</span></label>
                    <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={10000000} customUpload uploadHandler={fileUploade} />
                </div>
                <div className="field col-12 md:col-3">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} label="SUBMIT" type="submit"></Button>
                </div>
            </form>
            <DataTable className="mt-2" style={{ border: '1px solid #696969', borderTopWidth: "0" }}
                size="small" value={documentsList.consultant_documents} header="Consultant Document List" showGridlines stripedRows loading={loading}
            >
                <Column field="document_Name" header="Document Name" />
                {/* <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} /> */}
                <Column field="expiration_Date" header="Expiration Date" body={(rowData: any) => safeFormatDate(rowData.expiration_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="file" header="File" body={file} />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
                <Column field="document_Status" header="Status" body={document_Status} />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
            </DataTable>
            <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={documentsList.vendor_documents} header="Vendor Document List" showGridlines stripedRows loading={loading}
            >
                <Column field="document_Name" header="Document Name" />
                {/* <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} /> */}
                <Column field="expiration_Date" header="Expiration Date" body={(rowData: any) => safeFormatDate(rowData.expiration_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="file" header="File" body={file} />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
                <Column field="document_Status" header="Status" body={document_Status} />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
            </DataTable>
            <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={documentsList.client_documents} header="Client Document List" showGridlines stripedRows loading={loading}
            >
                <Column field="document_Name" header="Document Name" />
                {/* <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} /> */}
                <Column field="expiration_Date" header="Expiration Date" body={(rowData: any) => safeFormatDate(rowData.expiration_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="file" header="File" body={file} />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
                <Column field="document_Status" header="Status" />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
            </DataTable>
            <LeagleComments open={openClauseModal.open} singleData={openClauseModal.singleData} onClose={() => setOpenClauseModal({ open: false, singleData: {} })} toast={props.toast} />
        </Dialog>
    );
}